export interface UserPemission {
    [K: string]: boolean
}
export class PemisionState {
    observers: Map<string, Array<HTMLElement>> = new Map()
    constructor(public userPemission: UserPemission) {
    }
    register(el: HTMLElement, name: string) {
        el.style.display = this.userPemission[name] ? 'display': 'none'
        if (this.observers.has(name)) {
            let observer = this.observers.get(name)
            observer?.push(el)
        } else {
            this.observers.set(name, [el])
        }
        
    }
  }